import { FormField, TableColumn } from '../interface/interface';
export const scopeKeyLeadManagement = 'lead management';
export const scopeKeyPitchForm = 'pitch form';
export const STEP_DEFINITIONS = {
    ALREADY_MEMBER: {
        key: 'alreadyMember',
        subTitle: 'Already Member',
        clickable: true
    },
    EMAIL: {
        key: 'email',
        subTitle: 'Email Verification'
    },
    CONTACT: {
        key: 'contact',
        subTitle: 'Contact Details'
    },
    BUSINESS: {
        key: 'business',
        subTitle: 'Business Details'
    }
};
export const DATE_FORMAT = 'dd/MM/yyyy';

export const basicDetailsFields: FormField[] = [
    {
        label: 'Have you previously applied for Business Expansion Service? *',
        type: 'select',
        name: 'haveYouFill',
        required: true,
        disabled: false,
        placeholder: 'Have you previously applied',
        component: 'input',
        errorMessage:
            'Have you previously applied for business expansion service'
    },
    {
        label: 'Are you a Chamber Member? *',
        type: 'select',
        name: 'member',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Are you a Chamber Member',
        errorMessage: 'Are you a Chamber Member'
    },
    {
        label: 'Company Name *',
        type: 'text',
        name: 'companyName',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter company name',
        errorMessage: 'Company name'
    },
    {
        label: 'Membership Number *',
        type: 'number',
        name: 'dcMembershipNumber',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter member number',
        errorMessage: 'Member number'
    },
    {
        label: 'Trade License Number *',
        type: 'number',
        name: 'tradeLicenseNumber',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter trade license number',
        errorMessage: 'Trade license number'
    },
    {
        label: 'Attach the Trade License *',
        type: 'file',
        name: 'attachtradeLicenseDoc',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select file',
        errorMessage: 'Trade license attachment'
    },
    {
        label: 'Attach the Membership Certificate *',
        type: 'file',
        name: 'attachMembershipDoc',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Select file',
        errorMessage: 'Membership certificate'
    }
];

export const contactDetailsFields: FormField[] = [
    {
        label: 'Name *',
        type: 'text',
        name: 'contactName',
        required: true,
        component: 'input',
        placeholder: 'Enter contact name',
        errorMessage: 'Name'
    },
    {
        label: 'Designation *',
        type: 'text',
        name: 'jobTitle',
        component: 'input',
        required: true,
        placeholder: 'Enter designation',
        errorMessage: 'Designation'
    },
    {
        label: 'Email *',
        type: 'text',
        name: 'businessEmail',
        required: true,
        component: 'input',
        placeholder: 'Enter email',
        errorMessage: 'Email'
    },
    {
        label: 'Phone Number *',
        type: 'phone',
        name: 'phoneNumber',
        required: true,
        component: 'input',
        placeholder: 'Enter phone number',
        errorMessage: 'Phone Number'
    }
];

export const seniorManagementDetailsFields: FormField[] = [
    {
        label: 'Name *',
        type: 'text',
        name: 'companyOwnerName',
        required: true,
        component: 'input',
        placeholder: 'Enter owner/ceo name',
        errorMessage: 'Name'
    },
    {
        label: 'Designation *',
        type: 'text',
        name: 'companyOwnerDesignation',
        required: true,
        component: 'input',
        placeholder: 'Enter designation',
        errorMessage: 'Designation'
    },
    {
        label: 'Email *',
        type: 'text',
        name: 'companyOwnerEmail',
        required: true,
        component: 'input',
        placeholder: 'Enter email',
        errorMessage: 'Email'
    },
    {
        label: 'Company Website *',
        type: 'text',
        name: 'website',
        component: 'input',
        placeholder: 'Enter company website',
        required: true,
        errorMessage: ' Company Website '
    },
    {
        label: 'Attach Company Profile *',
        type: 'file',
        name: 'attachCompanyProfile',
        required: true,
        component: 'input',
        placeholder: 'Select file',
        errorMessage: 'Company Profile'
    },
    {
        label: 'Company Physical Address *',
        type: 'text',
        name: 'companyPhysicalAddress',
        disabled: false,
        required: true,
        placeholder: 'Enter company physical address',
        errorMessage: 'Company Physical Address',
        component: 'textarea' as 'textarea'
    }
];

export const BusinessDetailsFields: FormField[] = [
    {
        name: 'numberOfEmployees',
        type: 'select',
        disabled: false,
        label: 'Number of Employees *',
        required: true,
        component: 'input',
        placeholder: 'Select number of employees',
        errorMessage: 'Number of Employees'
    },
    {
        name: 'isYourCompanyHeadquarteredInDubai',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Is your company headquartered in Dubai or is it a branch, or representative office? *',
        required: true,
        placeholder: 'Select company headquartered in Dubai',
        errorMessage: 'Company Headquartered'
    },
    {
        name: 'numberOfYearsOperatingInDubai',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Number of years operating in Dubai *',
        required: true,
        placeholder: 'Select number of years',
        errorMessage: 'Years of Operating'
    },
    {
        name: 'annualRevenue',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Company’s Annual Turnover in USD *',
        required: true,
        placeholder: 'Select revenue',
        errorMessage: 'Company’s Annual Turnover'
    },
    {
        name: 'industry',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Industry *',
        required: true,
        placeholder: 'Select Industry',
        errorMessage: 'Industry'
    },
    {
        label: 'Other Business Sector*',
        name: 'otherBusinessSector',
        required: true,
        type: 'text',
        placeholder: 'Enter Other Business Sector',
        errorMessage: 'Other Business Sector',
        component: 'input'
    },
    {
        name: 'productAndServices',
        type: 'text',
        component: 'textarea' as 'textarea',
        label: 'Brief outline of products/services of your company *',
        required: true,
        placeholder: 'Enter Brief outline of products/services of your company',
        errorMessage: 'Brief outline of products/services of your company'
    },
    // {
    //     name: 'businessPurpose',
    //     disabled: false,
    //     required: true,
    //     label: 'Your company is interested in *',
    //     placeholder: 'Select business purpose',
    //     type: 'multiSelect',
    //     errorMessage: 'Your company is interested in'
    // },
    // {
    //     label: 'Please specify others for your company is interested in*',
    //     type: 'text',
    //     name: 'pleaseSpecifyOthersCompanyIsInterested',
    //     required: true,
    //     placeholder: 'Enter specify other company is interested',
    //     errorMessage: 'Others for your company is interested in'
    // },
    {
        name: 'currentInternationalMarketsCompany',
        disabled: false,
        required: true,
        label: 'Current international markets your company is operating in *',
        placeholder: 'Select current international markets',
        type: 'multiSelect',
        errorMessage: 'Current International Markets'
    },
    {
        name: 'areYourProductsManufacturedInDubai',
        disabled: false,
        required: true,
        type: 'select',
        label: 'Are your products manufactured, assembled or packaged in Dubai? *',
        placeholder: 'Select your products manufactured',
        errorMessage: 'Products Manufactured'
    }
];

export const previousExperienceField = [
    // {
    //     name: 'doYouHaveAnyPreviousExperience',
    //     disabled: false,
    //     required: true,
    //     label: 'Do you have any previous experience in the selected markets?  *',
    //     placeholder: 'Select previous experience',
    //     type: 'radio',
    //     errorMessage: 'Previous experience in the selected markets'
    // },
    {
        label: 'Please provide a detailed description of how your company plans to expand into the selected markets?*',
        type: 'text',
        disabled: false,
        required: true,
        name: 'descriptionOfHowYourCompanyPlansToExpand',
        placeholder: 'Enter description',
        component: 'textarea' as 'textarea',
        errorMessage: 'Detailed Description',
        desc: '(Minimum 30 words)'
    },
    {
        label: 'Additional Information',
        type: 'text',
        disabled: false,
        required: false,
        name: 'additionalInformation',
        placeholder: 'Enter description',
        component: 'textarea' as 'textarea',
        errorMessage: 'Additional Information'
    }
];
export const industrySelect = [
    {
        name: 'industry',
        disabled: false,
        label: 'Business sectors your company is engaged in *',
        placeholder: 'Business sectors'
    },
    {
        name: 'industrySubcategory',
        label: 'Business Sub Sector *',
        placeholder: 'Business Sub Sector'
    }
];
export const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};
export const defaultValueForSelect = [
    { key: 'no', name: 'No' },
    { key: 'yes', name: 'Yes' }
];
export const columns: TableColumn[] = [
    {
        header: 'Country',
        key: 'targetMarket',
        type: 'select',
        width: '20%'
    },
    {
        header: 'Channel of Expansion',
        key: 'purposeOfExpansion',
        type: 'multiSelect',
        width: '50%'
    },
    {
        header: 'Previous Experience',
        key: 'previousExperience',
        type: 'select',
        width: '6%'
    },
    {
        header: 'Market Priority',
        key: 'marketPriority',
        type: 'select',
        width: '6%'
    }
];
export const disallowedEmailDomains = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'mailinator.com',
    'yopmail.com',
    'email.com',
    'aol.com',
    'icloud.com',
    'protonmail.com',
    'zoho.com',
    'gmx.com',
    'mail.com',
    'yandex.com',
    'qq.com',
    '163.com',
    '10minutemail.com',
    'tempmail.com',
    'guerrillamail.com',
    'trashmail.com',
    'fakeinbox.com',
    'dispostable.com',
    'sharklasers.com'
];

// Attraction-----------------------------

export const attractionBasicDetailsFields1: FormField[] = [
    {
        label: 'Company Name *',
        type: 'text',
        name: 'companyName',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter company name',
        errorMessage: 'Company name'
    }
];

export const Attraction_FORM_STEPS = [
    {
        key: 'basicDetails',
        subTitle: 'Basic Details',
        clickable: true
    },
    {
        key: 'email',
        subTitle: 'Email Verification'
    },
    {
        key: 'business',
        subTitle: 'Business Details'
    }
];

export const attractionBasicDetailsFields2: FormField[] = [
    {
        label: 'Contact Name *',
        type: 'text',
        name: 'contactName',
        required: true,
        disabled: false,
        component: 'input',
        placeholder: 'Enter contact name',
        errorMessage: 'Contact name'
    },
    {
        label: 'Designation *',
        type: 'text',
        name: 'designation',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter designation',
        errorMessage: 'Designation'
    },
    {
        label: 'Email *',
        type: 'text',
        name: 'businessEmail',
        disabled: false,
        required: true,
        component: 'input',
        placeholder: 'Enter email',
        errorMessage: 'Email'
    },
    {
        label: 'Phone Number *',
        type: 'phone',
        name: 'phoneNumber',
        required: true,
        component: 'input',
        placeholder: 'Enter phone number',
        errorMessage: 'Phone Number'
    },
    {
        label: 'Company Website *',
        type: 'text',
        name: 'website',
        component: 'input',
        placeholder: 'Enter company website',
        required: true,
        errorMessage: ' Company Website '
    }
];

export const attractionBusinessDetailsFields: FormField[] = [
    {
        name: 'industry',
        type: 'select',
        disabled: false,
        component: 'input',
        label: 'Industry *',
        required: true,
        placeholder: 'Select Industry',
        errorMessage: 'Industry'
    },
    {
        label: 'Location *',
        type: 'select',
        name: 'location',
        required: true,
        disabled: false,
        placeholder: 'Select location',
        errorMessage: 'Location'
    },
    {
        label: 'Number of Employees *',
        type: 'select',
        name: 'numberOfEmployees',
        required: true,
        disabled: false,
        placeholder: 'Select number of employees',
        errorMessage: 'Number of employees'
    },
    {
        label: 'Annual Revenue *',
        type: 'select',
        name: 'annualRevenue',
        required: true,
        disabled: false,
        placeholder: 'Select annual revenue',
        errorMessage: 'Annual revenue'
    },
    {
        label: 'Business Purpose *',
        type: 'select',
        name: 'businessPurpose',
        required: true,
        disabled: false,
        placeholder: 'Select business purpose',
        errorMessage: 'Business purpose'
    }
];
